// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__17Mt8","upload":"Small_upload___4A1q","imageWrap":"Small_imageWrap__2_MHK","removeBtn":"Small_removeBtn__22zBq"};